module.exports = __webpack_public_path__ + "static/media/Customer_Portal_explanation_v2.5b06357e.jpg";